import { render, staticRenderFns } from "./PaperTicketMailing.vue?vue&type=template&id=56f74a07&scoped=true&"
import script from "./PaperTicketMailing.vue?vue&type=script&lang=js&"
export * from "./PaperTicketMailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f74a07",
  null
  
)

export default component.exports